import { STORAGE_LOCATION } from 'constants/browserCache';
import { BrowserStorageDebug } from './BrowserStorageDebug';

export const SessionStorageDebug = () => {
  return <BrowserStorageDebug storageLocation={STORAGE_LOCATION.SESSION_STORAGE} />;
};
